import axios from 'axios'
// import Masonry from 'masonry-layout';
// import AnchorBlock from './anchor_block';
// import {Spinner} from 'spin.js'
import Cookies from 'js-cookie';

export default class WPAjax {
    /**
     * @param {String} postType
     * @param {Object} customOptions Options to override
     * @param {String} customOptions.url URL of the REST route, 9 times out of 10 leave blank and use post_resets
     * only change this if you 100% NEED to.
     * @param {Boolean} customOptions.append Whether to append to the bottom of the container or replace.
     * @param {Number} customOptions.loadQuantity How many new posts to show per ajax call.
     * @param {Object} customOptions.queryArgs WP_Query options in camel case e.g. posts_per_page becomes postsPerPage
     * @param {Object} customOptions.queryArgs.category The category or custom taxonomy
     * @param {String} customOptions.queryArgs.category.name The taxonomy you wish to query
     * @param {String | Number | Array} customOptions.queryArgs.category.value The value of the selected taxonomy to query for
     * @param {String} customOptions.queryArgs.category.field The field to query
     * @param {Number} customOptions.offset What post to begin at
     * @param {Function} customOptions.preProcesses Function to run before ajax
     * @param {Function} customOptions.postProcesses Function to run after ajax
     * @param {Function} customOptions.errorProcesses Function to run if ajax returns an error.
     * @param {Boolean} customOptions.scroll Whether or now we should scroll to the top if more results have been loaded,
     * false by default
     * @param {Boolean} customOptions.showLoading Whether or not to show spinner whilst we await for new results
     * @param {Object} loadMoreOptions Options for how we will load additional content, by default we add
     * a button after the container and use that.
     * @param {Boolean} loadMoreOptions.useBtn If you want to use a load more button, true as default
     * @param {H TMLElement | String} loadMoreOptions.btn if you want to use a different button.
     * @param {Boolean} loadMoreOptions.scrollLoad if you want to load additional posts when you reach the bottom of the
     * page or the element or the bottom of the page (whichever happens first).
     */
    constructor(postType = "post", customOptions= {}, loadMoreOptions = {}) {
        //whether or not we are loading new results
        this.loading = false;
        //the amount of times we have run the ajax query, may be useful in post/pre-processes
        this.runCount = 0;
        //the current y position which to load more results
        this.yLoad = 0;
        this.postCount = 99999;
        this.taxonomy = null;
        this.taxonomyValue = null;
        this.listCategories = false;
        this.results = null;

        let _this = this;

        /** getting the container with data-post-type, this container must be the direct parent not grandparent or
         *  great grandparent. */
        let container = document.querySelector(`*[data-post-type=${postType}]`);
        this.container = container;
        if(!container) {
            console.warn('A container for ' + postType + ' is not found on this page. If this is intended ' +
                'ignore this error. Else add data-post-type="' + postType + '" to the intended container')
        } else {
            if(container.dataset.postCount) {
                this.postCount = container.dataset.postCount;
            } else {
                console.warn('wp-ajax.js - Missing data-post-count on ' + postType + " container. This is needed" +
                    " to determine when to disable the button.");
            }

            if(container.dataset.taxonomy) {
                this.taxonomy = container.dataset.taxonomy;
            }

            if(container.dataset.taxonomyValue) {
                this.taxonomyValue = container.dataset.taxonomyValue;
            }

            this.yLoad = this.calculateYPos(container);
            /** Getting the options from the params and setting defaults for ones not set */
            this.options = {
                url: customOptions.url ?? window.location.origin + '/wp-json/queries/posts',
                append: customOptions.append ?? true,
                loadQuantity: customOptions.loadQuantity ?? 4,
                queryArgs: customOptions.queryArgs ?? {
                    currPage: 1,
                    // category: {
                    //     name: 'category',
                    //     value: '',
                    // }
                },
                offset: customOptions.offset ?? 10,
                preProcesses: customOptions.preProcesses ?? function (_this) {},
                postProcesses: customOptions.postProcesses ?? function (_this) {},
                errorProcesses: customOptions.postProcesses ?? function (_this) {},
                scroll: customOptions.scroll ?? false,
                showLoading: customOptions.showLoading ?? false,
            };

            this.loadMoreOptions = {
                useBtn: loadMoreOptions.useBtn ?? true,
                scrollLoad: loadMoreOptions.scrollLoad ?? false,
            }

            let btn;

            //disabling the button and sending the ajax request.
            let toggleBtn = (el) => {
                if(!this.loading) {
                    el.ariaPressed = "true";
                    el.disabled = true;
                    this.loading = false;
                    this.postAjax(postType, container, btn);
                }
            }

            /** Initialising the load more button if it does not exist or loading it from the options */
            if(this.loadMoreOptions.useBtn) {
                if(this.options.offset < this.postCount) {
                    //if we have set a button in the sent over options.
                    if (loadMoreOptions.btn) {
                        if (typeof loadMoreOptions.btn === "string") {
                            btn = document.querySelector(loadMoreOptions.btn);
                            if (!btn) {
                                throw new Error('wp-ajax.js - Provided load more button is not present on the current page');
                            }
                        } else {
                            btn = loadMoreOptions.btn
                        }

                        btn.ariaPressed = "false";
                        //creating a new button then appending after the container
                    } else {
                        btn = document.createElement('button');
                        btn.classList.add('btn', 'btn--load-more');
                        btn.innerText = 'Load more';
                        btn.ariaPressed = "false";
                        container.parentElement.insertBefore(btn, container.nextSibling)
                    }

                    btn.addEventListener('click', (e) => {
                        toggleBtn(e.target)
                    })

                    btn.addEventListener('keydown', (e) => {
                        // Check to see if space or enter were pressed
                        if (event.key === " " || event.key === "Enter" || event.key === "Spacebar") { // "Spacebar" for IE11 support
                            // Prevent the default action to stop scrolling when space is pressed
                            event.preventDefault();
                            toggleBtn(event.target);
                        }
                    })
                }
            }

            this.loadMoreOptions.btn = this.loadMoreOptions.useBtn === true ?  btn : undefined;

            /** If we have enabled the ability to load more posts when we scroll
             * then display additional posts
             * */
            if(this.loadMoreOptions.scrollLoad) {
                let ajaxScroll = () => {
                    let scrollY;
                    if(navigator.userAgent.indexOf('MSIE')!==-1
                        || navigator.appVersion.indexOf('Trident/') > -1){
                        scrollY = window.pageYOffset;
                    } else {
                        scrollY = window.scrollY;
                    }

                    //the position of the container
                    let top = container.getBoundingClientRect().top + window.scrollY;
                    //the position of the bottom of the container.
                    let bottom = top + container.offsetHeight;
                    //amount to add to bottom of el
                    const offset = 100;

                    //the position of the bottom of the page.
                    scrollY = scrollY + window.innerHeight;
                    let triggerPos = bottom + offset
                    // let triggerPos = ((container.scrollTop + window.innerHeight) + container.offsetHeight) - ((window.innerHeight/3)*2);
                    // let triggerPos = ((container.scrollTop + window.innerHeight) + container.offsetHeight) - ((window.innerHeight/3)*2);
                    if(scrollY > triggerPos) {
                        if(this.loadMoreOptions.useBtn) {
                            toggleBtn(this.loadMoreOptions.btn);
                        } else {
                            this.postAjax(postType, container, null);
                        }
                    }
                }
                window.removeEventListener('scroll', ajaxScroll)
                window.addEventListener('scroll', ajaxScroll);
            }

            // console.log("Options: ", this.options);
        }
    }

    /**
     *
     * @param post_type {String} Post type name
     * @param container {HTMLElement} Where to append ajax results to.
     */
    postAjax(postType, container, btn) {
        if(!this.loading && this.options.offset < this.postCount) {
            var that = this;
            that.loading = true;
            let website = window.location.origin + '/wp-json/queries/posts';

            if (this.options.scroll) {
                window.scroll({
                    top: container.getBoundingClientRect().top,
                    left: 0,
                    behavior: 'smooth',
                })
            }

            if (this.options.showLoading) {
                let spinner_div = document.createElement('div');
                let loading_div = document.createElement('div');
                loading_div.classList.add('loading');
                container.appendChild(spinner_div);
                container.appendChild(loading_div);
                var spinner = new Spinner({
                    lines: 17, // The number of lines to draw
                    length: 20, // The length of each line
                    width: 17, // The line thickness
                    radius: 45, // The radius of the inner circle
                    scale: 0.4, // Scales overall size of the spinner
                    corners: 1, // Corner roundness (0..1)
                    speed: 1, // Rounds per second
                    rotate: 0, // The rotation offset
                    animation: 'spinner-line-fade-quick', // The CSS animation name for the lines
                    direction: 1, // 1: clockwise, -1: counterclockwise
                    color: '#143456', // CSS color or array of colors
                    fadeColor: 'transparent', // CSS color or array of colors
                    top: '50%', // Top position relative to parent
                    left: '50%', // Left position relative to parent
                    shadow: '0 0 1px transparent', // Box-shadow for the lines
                    zIndex: 2000000000, // The z-index (defaults to 2e9)
                    className: 'spinner', // The CSS class to assign to the spinner
                    position: 'absolute', // Element positioning
                }).spin(spinner_div);
            }

            // that.options.queryArgs.offset = that.options.offset;
            // that.options.queryArgs.ajaxCount = that.runCount;
            // that.options.queryArgs.postsPerPage = that.options.loadQuantity;

            this.options.preProcesses(this);
            axios.post(this.options.url, {
                postType,
                props: that.options.queryArgs,
                postsPerPage: that.options.loadQuantity,
                offset: that.options.offset,
                ajaxCount: that.runCount,
                lang: Cookies.get('pll_language') ?? null,
                listCategories: this.listCategories,
                taxonomy: {
                    name: that.taxonomy,
                    value: that.taxonomyValue,
                }
            })
            .then((result) => {
                // console.log(result);
                //if we are set to replace mode replace the current innerHTML
                //with the results of the ajax call.
                if (!this.options.append) {
                    container.innerHTML = result.data.html;
                    this.yLoad = that.calculateYPos(container);
                    //else we are on append mode so add to the end of the container
                } else {
                    container.insertAdjacentHTML('beforeend', result.data.html);
                }

                this.runCount++;
                this.results = result.data;
                this.options.postProcesses(this);
                this.loading = false;
                this.options.offset = this.options.offset + this.options.loadQuantity;
                this.yLoad = this.getPosition(container).bottom + 100;

                //if we are using a load more button assure the aria-pressed is false for accessibility
                if (this.loadMoreOptions.useBtn) {
                    this.loadMoreOptions.btn.disabled = false;
                    this.loadMoreOptions.btn.ariaPressed = "false";

                    //if the offset is greater than the post type.
                    if(this.postCount && this.options.offset >= this.postCount) {
                        this.loadMoreOptions.btn.remove();
                        this.loadMoreOptions.useBtn = false;
                    }
                }
            }, (error) => {
                // console.log(error)
                this.options.errorProcesses(this);
            });
        }
    }

    /**
     * Calculate yScroll location to display more posts.
     */
    calculateYPos(container) {
        //console.log('container', container, this.getPosition(container).bottom);
        let newYPos = this.getPosition(container).bottom - window.innerHeight;
        return newYPos;
    }

    getPosition(el) {
        var rect = el.getBoundingClientRect();
        var docEl = document.documentElement;
        return {
            left: rect.left + (window.pageXOffset || docEl.scrollLeft || 0),
            top: rect.top + (window.pageYOffset || docEl.scrollTop || 0),
            bottom: rect.bottom + (window.pageYOffset || docEl.scrollTop || 0),
            right: rect.right + (window.pageYOffset || docEl.scrollTop || 0),
        };
    }
}